// extracted by mini-css-extract-plugin
export default {"cellDivider":"CellDivider-module__cellDivider___X3onD","onTopOfPills":"CellDivider-module__onTopOfPills___bh7FV","bold":"CellDivider-module__bold___XdGd3"};